module.exports = __webpack_public_path__ + "img/westland_gasnetwerk.edd5b9c7.png";